import React from 'react';
import { modules, promises } from '../data/modules';
import { OFFER_ANCHOR, PRODUCT_ALT, PRODUCT_IMG, PRODUCT_NAME } from './constants';
export function SystemSection() {
  return <section className="bg-white px-4 py-5" data-id="element-123" data-mp="3bimxngbqr96h">
      <div className="mx-auto max-w-4xl" data-id="element-124" data-mp="3bhlojheacwre">
        <div className="mb-3 text-center" data-id="element-125" data-mp="36jshkm55ryq2">
          <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-orange sm:text-sm" data-id="element-126" data-mp="36iqv7liozpt1">
            Le système complet que vous recherchiez
          </p>
          <h2 className="mb-1 font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-127" data-mp="2wtqunxojkmcq">
            Un seul système domotique 6-en-1
          </h2>
          <div className="mb-2 inline-block rounded-lg bg-brand-graphite px-3 py-1.5 text-white shadow-md" data-id="element-128" data-mp="2ntascrjjbl9g">
            <p className="font-display text-xs font-bold uppercase tracking-wide text-white sm:text-base" data-id="element-129" data-mp="2ity3k193s448">
              {PRODUCT_NAME}
            </p>
            <p className="text-[11px] font-semibold text-white/85 sm:text-sm" data-id="element-130" data-mp="2dvo8rrraj5j5">
              Le Système Complet pour Apprendre, Installer et Maîtriser la Maison Connectée
            </p>
          </div>
          <p className="mx-auto max-w-3xl text-[13px] font-medium leading-snug text-brand-muted sm:text-base" data-id="element-131" data-mp="18r96omicfxbq">
            Ce n’est pas une nouvelle collection d’informations dispersées sur la domotique. C’est un
            parcours progressif conçu pour vous accompagner des fondamentaux jusqu’à la réalisation
            méthodique de projets domotiques complets. Avec {PRODUCT_NAME}, vous pouvez :
          </p>
          <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-[11px] font-semibold text-brand-ink sm:text-sm" data-id="element-132" data-mp="1rmps1cr4fywl">
            {promises.map(promise => <li key={promise} data-id="element-133" data-mp="1horyqauenbx4">✔ {promise}</li>)}
          </ul>
        </div>

        <div className="grid gap-2 sm:grid-cols-2" data-id="element-134" data-mp="1atft6nlr89n">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="group flex gap-3 rounded-xl border border-brand-line bg-brand-cream p-3 shadow-sm transition-colors duration-150 ease-out hover:border-brand-orange" data-id="element-135" data-mp="6d0vo7bjz8h9">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-graphite font-display text-sm font-extrabold text-white transition-colors duration-150 ease-out group-hover:bg-brand-orange" data-id="element-136" data-mp="1z7jo69fpac8y">
                {module.num}
              </span>
              <div data-id="element-137" data-mp="1l8scetob92nz">
                <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-138" data-mp="1l8aiw4t192jr">
                  ✅ {module.title}
                </h3>
                <p className="mt-0.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-139" data-mp="1gbaahn8pnnph">
                  {module.description}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-3 text-center" data-id="element-140" data-mp="35onc34pfuxmw">
          <a href={OFFER_ANCHOR} className="inline-block" aria-label="Aller à la section d’achat" data-id="element-141" data-mp="35owzckj3mqow">
            <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[220px] object-contain drop-shadow-xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-142" data-mp="3d7dbc3ejdc8h" />
          </a>
        </div>
      </div>
    </section>;
}